import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#E94B35", d: "M3.334 10.667h12v10a6 6 0 0 1-12 0z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M12.667 22.667 13.333 24l-.666 1.333L12 24zm-6.667 0L6.667 24 6 25.333 5.333 24z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M11.7 25.667c.154-.628-1.255-4.164-1.088-4.083 1.742.853 3.617.72 4.318.81-.299-1.363.488-5.376.134-8.117-.283-2.189-1.454-2.75-1.902-2.457.814 1.48-.648 2.747-1.308 3.483-1.215-.84-1.104-1.685-.921-2.003 1.067.244 1.483-.248 1.645-.757.24-.757-.877-.985-1.283-.946Q9.878 11.733 9.333 14q-.55-2.267-1.964-2.403c-.406-.039-1.524.189-1.284.946.162.51.578 1.001 1.646.757.182.318.294 1.163-.922 2.002-.66-.735-2.122-2.002-1.307-3.482-.449-.293-1.62.268-1.903 2.457-.354 2.741.433 6.754.134 8.117.702-.09 2.576.043 4.318-.81.167-.081-1.242 3.455-1.088 4.083 0 0 1.14.53 2.37.525 1.043-.003 2.367-.525 2.367-.525",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#E94B35", d: "M6.667 15.333H12v3.334a2.667 2.667 0 0 1-5.333 0z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M9.8 17.533h2.867v.934H9.8V22h-.933v-3.533H6v-.934h2.867v-2.866H9.8z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M9.333 3.333c.184 0 .334.15.334.334v.666a.333.333 0 0 1-.667 0v-.666c0-.184.15-.334.333-.334",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "m5.31 8.543-.412-1.029a.67.67 0 0 1 .195-.762c1.145-.944 2.554-1.417 4.24-1.419 1.688 0 3.097.472 4.242 1.419a.67.67 0 0 1 .194.761l-.412 1.03a.333.333 0 0 0 .62.247l.411-1.03A1.33 1.33 0 0 0 14 6.239c-1.27-1.05-2.83-1.573-4.667-1.571-1.837.001-3.396.525-4.664 1.57-.448.37-.605.986-.39 1.525l.412 1.028a.333.333 0 0 0 .619-.247"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M11.98 5.825c.512.329.452 1.067-.33 2.333a.333.333 0 1 0 .567.35c.949-1.535 1.04-2.656.123-3.244a.333.333 0 1 0-.36.561m-5.293 0c-.512.329-.452 1.067.33 2.333a.333.333 0 0 1-.566.35c-.95-1.535-1.04-2.656-.124-3.244a.333.333 0 0 1 .36.561M9 5v3.333a.333.333 0 1 0 .667 0V5A.333.333 0 1 0 9 5"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M9.334 5.333a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333m-4 4.667-.667-1.333s2.215-.674 4.667-.67c2.451.006 4.666.67 4.666.67L13.334 10v.667h-8z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagSrb = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagSrb_default = SvgFlagSrb;

export { FlagSrb_default as default };
